export const systemParameterSilos = 1;